import db from "./db.js"

const util = {}
util.getLanguage = () => {
	return db.get("sys.public.language.value").value() || "zh"
}
util.getConfig = () =>{
	return window.WIN_GLOBAL?{...process.env,...window.WIN_GLOBAL}:process.env
}
util.getIpUrl = function (vue){
	let url = location.href.replace(vue.$route.path, "")
	let index = url.indexOf("?")
	if (index > -1) {
		return url.substr(0, index)
	}
	return url
}

/**
 * 判断是否为空
 * @param {*} val
 */
util.isEmpty = function (val){
	if (val instanceof Array) {
		if (val.length === 0) return true
	}
	else if (val instanceof Object) {
		if (JSON.stringify(val) === "{}") return true
	}
	else {
		if (val == null || val === undefined || val === "") return true
		return false
	}
	return false
}

/**
 * 判断是否不为空
 * @param {*} val
 */
util.isNotEmpty = function (val){
	return !util.isEmpty(val)
}

/**
 * 判断是否为微信浏览器
 */
util.isWeChatBrowser = function (){
	const ua = window.navigator.userAgent.toLowerCase()
	//通过正则表达式匹配ua中是否含有MicroMessenger字符串
	if (ua.match(/MicroMessenger/i) == "micromessenger") {
		return true
	}
	else {
		return false
	}
}

/**
 * 判断是否为企业微信浏览器
 */
util.isWorkWeChatBrowser = function (){
	const ua = window.navigator.userAgent.toLowerCase()
	//通过正则表达式匹配ua中是否含有wxwork字符串
	if (ua.match(/WxWork/i) == "wxwork") {
		return true
	}
	else {
		return false
	}
}

export default util
